import { Spinner } from '@components/core-ui/spinners/Spinner';
import styled from 'styled-components';

export const StyledSpinner = styled(Spinner)`
  height: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
